export enum SearchDomain {
	Course = "COURSE",
	Article = "ARTICLE",
	Quiz = "QUIZ",
	User = "USER",
	Organization = "ORGANIZATION",
	Shareroom = "SHAREROOM",
	Discussion = "DISCUSSION",
	Carousel = "CAROUSEL",
}

export const allSearchDomains = [
	SearchDomain.Article,
	SearchDomain.Shareroom,
	SearchDomain.Discussion,
	SearchDomain.Course,
	SearchDomain.Quiz,
	SearchDomain.Carousel,
	SearchDomain.User,
	SearchDomain.Organization,
];

export const allSearchFilters = [
	"COURSE",
	"ARTICLE",
	"QUIZ",
	"USER",
	"CAROUSEL",
	"INSTITUTE",
	"COMPANY",
	"SHAREROOM",
	"DISCUSSION",
];

export const allSearchFiltersWithHeaders = [
	"CHANNELS",
	// -----------
	"SHAREROOM",
	"DISCUSSION",

	// ---------
	"CONTENT",
	// ----------
	"COURSE",
	"ARTICLE",
	"QUIZ",
	"CAROUSEL",
	// ---------
	"PAGES",
	// ---------
	"USER",
	"INSTITUTE",
	"COMPANY",
];

export const searchFiltersHeaders = ["CONTENT", "PAGES", "CHANNELS"];
